module.exports = __webpack_public_path__ + "f64a549173d9908c5266eeb18c4cafe9.pdf";